module.exports = __webpack_public_path__ + "static/media/facebook-logo.e3cd1b21.svg";